import   React                   ,
       { useState                ,
         useEffect               ,
         useRef                  }  from "react";

import { useLocation                 ,
         useNavigate                 }  from 'react-router-dom';

import   classNames                 from "classnames";

import   styles                     from "./Header.module.scss";






import { getConfiguration      }  from '../../../backendServices/configurationManagment/api';





import   Trigger                    from '../../widget/actuators/Trigger';
import   CreatorAccountPanel        from './CreatorAccountPanel';
import   KleonCredits                from './KleonCredits';

import { useTypedSelector        }  from '../../../store/useTypeSelector';
import { RootState               }  from '../../../store/generalReducer';

import { Dispatch                }  from 'redux';

import { initAuthentication      }  from '../../../store/adminAuthenticationManagment/actions';
import { useMediaStream          }  from '../../../contexts/MediaStreamContext';
import { quotaAtteint            ,
         afficherLimite          ,
         estSansLimite           ,
         partRestante            }  from '../../../dataTypes/adminManagment/quota';
import { updateBooleanMap        }  from '../../../store/demoManagment/actions';

import { useDispatch             ,
         useSelector             }  from 'react-redux';

import   TaskManager                from '../tasksManagment/TaskManager';
import   CommunityMessageManager    from './CommunityMessageManager';
import   CommunityMessageComposer   from './CommunityMessageComposer';
import   StorageBreakdownPopover    from './StorageBreakdownPopover';
import { useCommunityMessages    }  from './useCommunityMessages';
import { useLiveAdminUsage       }  from './useLiveAdminUsage';

const Header: React.FC = () => {

  const   dispatch: Dispatch<any> = useDispatch();
  const   navigate                = useNavigate();

  const { closeAllChannelSessions } = useMediaStream();
  // Valeur inutilisée, mais l'abonnement est conservé : le retirer changerait
  // la fréquence de rendu du composant.
  useLocation();

  useSelector((state: RootState) => state.booleanMapReducer);
  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  // « Superadmin » dans la bouche de l'exploitant, 'ADMIN' dans les données :
  // c'est le rôle qui ouvre déjà le Tableau de bord, les Produits et les
  // Utilisateurs (cf. desktop.tsx). Il n'y en a pas d'autre au-dessus.
  const isSuperadmin = authentication.admin?.role === 'ADMIN';

  // Le relevé ne tourne que pour un compte identifié : sur l'écran de connexion
  // il n'y a personne à qui parler, et l'API n'a pas à être sollicitée.
  const communityMessages = useCommunityMessages(!!authentication.admin, authentication.admin?.id ?? null);

  // Devices, Chaînes et Stockage de l'en-tête : relevés toutes les 15 s (cf. useLiveAdminUsage).
  useLiveAdminUsage(authentication.admin?.id ?? null);



  // 7 jours glissants (le jour courant étant le dernier jour)

  // Mois courant

  // Mois précédent

  // Année courante (du 1er janvier jusqu'à aujourd'hui)

  // Année précédente (du 1er janvier au 31 décembre)





  const [ showAccountMenu                 , setShowAccountMenu                 ] = useState(false);
  const [ showAccountPanel                , setShowAccountPanel                ] = useState(false);
  const   accountMenuRef                  = useRef<HTMLDivElement>(null);

  useEffect(() => {

    const handleClickOutside = (e: MouseEvent) => {
      if (accountMenuRef.current && !accountMenuRef.current.contains(e.target as Node)) {
        setShowAccountMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);

  }, []);

  const extractBrowserAndOS = (userAgentString: string) => {

    console.log (" ~~~~~~~~ extractBrowserAndOS ", userAgentString, authentication)

    // Vérifier si la chaîne est vide ou invalide
    if (!userAgentString || userAgentString.trim() === '') {
      return '';
    }

    try {
      const userAgentData = JSON.parse(userAgentString);

      // Vérifier que c'est bien un objet
      if (typeof userAgentData !== 'object' || userAgentData === null) {
        return '';
      }

      // Vérifier que les propriétés nécessaires existent
      const browserName = userAgentData?.browser?.name || 'Navigateur inconnu';
      const osName = userAgentData?.os?.name || 'OS inconnu';

      // Ne retourner la chaîne que si au moins une des valeurs est présente
      if (browserName === 'Navigateur inconnu' && osName === 'OS inconnu') {
        return '';
      }

      return `${browserName} / ${osName}`;
    }
    catch (error) {
      console.error("Erreur lors de l'analyse de la chaîne JSON:", error);
      console.error("Chaîne reçue:", userAgentString);
      return '';
    }
  };

  const [ adminFirstName                  , setAdminFirstName                  ] = useState (authentication.admin ? authentication.admin.firstname : '')
  const [ adminLastName                   , setAdminLastName                   ] = useState (authentication.admin ? authentication.admin.lastname  : '')
  const [                        , setAdminRole                       ] = useState ('Super-admin')
  const [                   , setAdminLastLogin                  ] = useState (authentication.admin ? ( authentication.admin.lastLoginDate?.toLocaleString() ?? '' ) : '')
  const [          , setAdminAuthenticationCity         ] = useState (authentication.admin ? authentication.admin.lastLoginCity : '' )
  const [        , setAdminAuthenticationDevice       ] = useState (authentication.admin ? extractBrowserAndOS (authentication.admin.lastLoginDevice) : '' )

  const initConfiguration = async () => {

	  const result = await getConfiguration ()

	  if ( result.code === 1 )
	   {
 	    dispatch ( updateBooleanMap ( 'SVOD'                 , result.payload.svod                 ) );
 	    dispatch ( updateBooleanMap ( 'Diffusion'         , result.payload.broadcasting         ) );
 	    dispatch ( updateBooleanMap ( 'Restream'             , result.payload.restream             ) );
 	    dispatch ( updateBooleanMap ( 'Boutique'                 , result.payload.shop                 ) );
 	    dispatch ( updateBooleanMap ( 'Campagne QRcode/CTA'        , result.payload.salesCampaign        ) );
 	    dispatch ( updateBooleanMap ( 'Gestion des annonceurs' , result.payload.advertiserManagement ) );
 	    dispatch ( updateBooleanMap ( 'Compagnon IA'          , result.payload.AICompanion          ) );
 	    dispatch ( updateBooleanMap ( 'Sondage'                 , result.payload.poll                 ) );
 	    dispatch ( updateBooleanMap ( 'Chat'                 , result.payload.chat                 ) );
	   }
  }

  const initAdminInformations = () => {

    setAdminFirstName            (authentication.admin ?   authentication.admin.firstname : '')
    setAdminLastName             (authentication.admin ?   authentication.admin.lastname  : '')
    setAdminRole                 (authentication.admin ?   authentication.admin.role  : '')
    setAdminLastLogin            (authentication.admin ? ( authentication.admin.lastLoginDate?.toLocaleString() ?? '' ) : '')
    setAdminAuthenticationCity   (authentication.admin ?   authentication.admin.lastLoginCity : '' )
    setAdminAuthenticationDevice (authentication.admin ?   extractBrowserAndOS (authentication.admin.lastLoginDevice) : '' )

  }


 useEffect(() => {

   initConfiguration ()
   initAdminInformations ()

  }, []);

/*
 useEffect(() => {

   initAdminInformations ()

  }, [authentication]);

 useEffect(() => {

   initConfiguration ()
   
  }, [booleanMap]);
*/



  ////////////////// Admin infos

  



  


  /////////////////////////

  const handleLogoutClick = () => {

    // Le créateur s'en va : c'est le seul moment où l'on coupe ses caméras. Tant
    // qu'il est là, elles survivent aux changements de chaîne et d'onglet — voir
    // ChannelSession dans MediaStreamContext.
    closeAllChannelSessions();

    dispatch ( initAuthentication(true) );
    navigate ('/')
  }







/*
  return (
    <div className={classNames(styles.header)}>

      {showWaitingIcon && <AnimatedWaitingIcon2 />}

      <div className={classNames(styles.headerLeft)}>
        {renderLogo()}
		<div className={classNames(styles.headerLeftTitle)}>
	      { showChoices && <>ESPACE DEMO</>}
		 
		   <Toggle checked={showChoices} form="switch" onChange={handleChoicesClick} /> 
		  
		</div>
      </div>

      <div className={classNames(styles.headerRight)}>
        <div className={classNames(styles.platformChoice)}>
          {renderPlatformChoice()}
        </div>
		<div className={classNames(styles.choicesTab)}>
          { showChoices && (renderChoices()) }
        </div>

        <div className={classNames(styles.uploadManager)}>
          <UploadManager />
        </div>
        <div className={classNames(styles.nightAndDay)}>
<Toggle checked={nightAndDay}
        fillColorOn="var(--color-NightAndDayToggle-On)"
        fillColorOff="var(--color-NightAndDayToggle-Off)"
        width="66px"
        height="37px"
        form="switch"
        show="icon"
        iconOn="sun"
        iconOff="moon"
        iconColorOn="var(--color-NightAndDayToggle-Icon-On)"
        iconColorOff="var(--color-NightAndDayToggle-Icon-Off)"
        internalPosition={false}
        persistentIcons={true}
        onChange={handleNightAndDayClick} />
        </div>
        <div className={classNames(styles.logout)}>
          <Trigger name="Deconnexion" onClick={handleLogoutClick} variant="tailwind2" height="10%" />
        </div>
        <div className={classNames(styles.adminInformations)}>
          {renderAdminInformations()}
        </div>
      </div>

    </div>
  );

  */

  const quotaDiskBytes    = authentication.admin?.quotaDisk ?? 0;
  const quotaUsedBytes    = authentication.admin?.quotaUsed ?? 0;
  // Sous 100 Mo utilisés, tout s'écrit en Mo (utilisé ET total) ; au-delà, en Go.
  const quotaInGo           = quotaUsedBytes >= 100 * 1024 * 1024;
  const quotaDivisor        = quotaInGo ? 1024 * 1024 * 1024 : 1024 * 1024;
  const quotaDiskDisplay    = (quotaDiskBytes / quotaDivisor).toFixed(2);
  const quotaUsedDisplay    = (quotaUsedBytes / quotaDivisor).toFixed(2);
  const quotaUnit           = quotaInGo ? 'Go' : 'Mo';
  const quotaRemainingRatio = partRestante(quotaUsedBytes, quotaDiskBytes);
  const quotaIsLow          = quotaRemainingRatio < 0.1;

  const nbDevicesMax     = authentication.admin?.nbDevicesMax  ?? 0;
  const nbDevicesUsed    = authentication.admin?.nbDevicesUsed ?? 0;
  const devicesIsLow     = quotaAtteint(nbDevicesUsed, nbDevicesMax);

  const nbChannelsMax    = authentication.admin?.nbChannelsMax  ?? 0;
  const nbChannelsUsed   = authentication.admin?.nbChannelsUsed ?? 0;
  const channelsIsLow    = quotaAtteint(nbChannelsUsed, nbChannelsMax);

  return (
    <div className={classNames(styles.headerBis)}>

        <div className={classNames(styles.uploadManagerBis)}>
          <TaskManager />
        </div>

        {/* Le message reçu se place à côté des envois : deux bandeaux de même
            nature, au même endroit, dans la même langue visuelle. */}
        <div className={classNames(styles.uploadManagerBis)}>
          <CommunityMessageManager state={communityMessages} adminId={authentication.admin?.id ?? null} />
        </div>

        {isSuperadmin && (
          <div className={classNames(styles.uploadManagerBis)}>
            <CommunityMessageComposer
              authorId   = {authentication.admin?.id ?? null}
              authorName = {[authentication.admin?.firstname, authentication.admin?.lastname]
                              .filter(Boolean).join(' ')}
              onSent     = {communityMessages.refresh}
            />
          </div>
        )}
		
		{/*
        <div className={classNames(styles.nightAndDayBis)}>
          <Toggle checked={nightAndDay}
                  fillColorOn      = "var(--color-NightAndDayToggle-On)"
                  fillColorOff     = "var(--color-NightAndDayToggle-Off)"
                  width            = "44px"
                  height           = "24px"
                  form             = "switch"
                  show             = "icon"
                  iconOn           = "sun"
                  iconOff          = "moon"
                  iconColorOn      = "var(--color-NightAndDayToggle-Icon-On)"
                  iconColorOff     = "var(--color-NightAndDayToggle-Icon-Off)"
                  internalPosition = {false}
                  persistentIcons  = {true}
                  onChange         = {handleNightAndDayClick} />
        </div>
        */}
		
        <div className={classNames(styles.quotaInfo, devicesIsLow && styles.quotaWarning)}>
          Devices : {nbDevicesUsed}/{afficherLimite(nbDevicesMax)}
        </div>

        <div className={classNames(styles.quotaInfo, channelsIsLow && styles.quotaWarning)}>
          Chaînes : {nbChannelsUsed}/{afficherLimite(nbChannelsMax)}
        </div>

        <StorageBreakdownPopover adminId={authentication.admin?.id ?? null}>
          <div className={classNames(styles.quotaInfo, quotaIsLow && styles.quotaWarning)}>
            Stockage : {quotaUsedDisplay}/{estSansLimite(quotaDiskBytes) ? '∞' : quotaDiskDisplay} {quotaUnit}
          </div>
        </StorageBreakdownPopover>

        <KleonCredits adminId={authentication.admin?.id ?? null} />

        <div ref={accountMenuRef} className={classNames(styles.accountMenuWrapper)}>
          
		  <Trigger name                       = {`${adminFirstName} ${adminLastName}`}
                   onClick                    = {() => setShowAccountMenu((v) => !v)}
                   variant                    = "tailwind2"
                   buttonForegroundColor      = "#FFFFFF"
                   buttonBackgroundColor      = "#2563EB"
                   buttonForegroundHoverColor = "#FFFFFF"
                   buttonBackgroundHoverColor = "#1D4ED8" />
		  
		  {/*
		  
		  <div className={classNames(styles.adminInformationsBis)}
               onClick={() => setShowAccountMenu((v) => !v)}>
            <div className={classNames(styles.adminInfoLine)}>
              {adminFirstName} {adminLastName}
            </div>
          </div>
          */}
		  
		  
          {showAccountPanel && authentication.admin?.id && (
            <CreatorAccountPanel adminId={authentication.admin.id} onClose={() => setShowAccountPanel(false)} />
          )}

          {showAccountMenu && (
            <div className={classNames(styles.accountDropdown)}>
			  <button className = {classNames(styles.button)}
					  onClick   = {() => { setShowAccountMenu(false); setShowAccountPanel(true); }}>Mon compte</button>
			  <button className = {classNames(styles.button)}>Mon abonnements</button>
			  <button className = {classNames(styles.button)}
					  onClick   = {handleLogoutClick}        >Se déconnecter</button>
            </div>
          )}
        </div>

    </div>
  )
};

export default Header;
